import ProductSelection from "../../../domains2/orders/ProductSelection";
import appConfig from "../../../appconfig";
import { store } from "../../../store";
import { evaluateCustomerType } from "../../utils";
import { getProductSpecificDiscount } from "../../../domains2/priceRules/priceRulesHelpers";
import {convertProductSelectionsToMap} from "../../../helper/ProductSelectionHelper";

const shouldShowDiscountPrice = (product, enableInGroupDiscount) => {
	if(
		product.discount
		&& product.discount.options
		&& product.discount.options.qualifyingProductIds
		&& product.discount.options.qualifyingProductIds.length
	) {
		return false;
	}
	return (product.discount && product.discount.options.discountScope !== "group") || product.discount && enableInGroupDiscount;
};

export const getProductPriceWithDiscounts = (
	products,
	productSelections,
	productCatalog,
	discountTypeDisable = ["familyDiscount"],
	enableInGroupDiscount = false
) => {
	const orderLines = ProductSelection.mapToOrderLinesGen(5)(
		productCatalog,
		productSelections,
		false,
		{
			channel: appConfig.channelAlias(),
			deliveryMethod: store.getters.tenantSpecificData && store.getters.tenantSpecificData.deliveryChoice,
			customerType: evaluateCustomerType(),
			dailySpending: store.getters.featureToggles.discountDailyLimit ? store.getters.applicationUserData
					&& store.getters.applicationUserData.meta
					&& store.getters.applicationUserData.meta.dailySpending : undefined,
			enableProductBestPriceInCatalogAndCart: store.getters.featureToggles.enableProductBestPriceInCatalogAndCart,
			cartProductsMap: convertProductSelectionsToMap(store.getters.cartProducts)
		},
		[],
		true,
		discountTypeDisable
	);
	return products.reduce((acc, product) => {
		const discountValue =
			shouldShowDiscountPrice(product, enableInGroupDiscount)
				? getProductSpecificDiscount({price: product.price, discount: product.discount})
				: 0;
		if (product.price) {
			return {...acc, [product.id]: {
				basePrice: product.price,
				discountPrice: discountValue > product.price ? product.price : product.price - discountValue
			}
			};
		} else {
			const orderLine = orderLines.find(orderLine => orderLine.productId === product.id);
			return {...acc, [product.id]: {
				basePrice: orderLine.totalPriceBeforeAccum || orderLine.totalPrice,
				discountPrice: orderLine.totalPriceAccum
			}
			};
		}
	}, {});
};

export const CUSTOMER_TRACKING_TAGS = Object.freeze({
	PENDING_ORDER_FREE_MEAL_REGISTER: "PENDING_ORDER_FREE_MEAL_REGISTER"
});

export const AUTH_FLOW_METHODS = Object.freeze({
	NORMAL: "normal",
	HISTORY: "history",
	CART: "cart",
	POPUP: "popup",
	QR: "QR",
	QR_NEW: "QR_NEW",
	AUTH_CODE: "auth_code"
});

export const AUTH_EVENT = Object.freeze({
	SIGN_UP: "sign_up",
	LOGIN: "login"
});

export const SUNSET_PLUS_UPSELL_MODAL_MINIMAL_SPENDING = 165;

export const getGlobalTemplateReplaceCssName = (tenantId, replaceCss) => {
	for (const key in replaceCss) {
		if (replaceCss[key].includes(tenantId)) {
			return key;
		}
	}
	return null;
};

export const generateRandomNumber = (max) => {
	return Math.floor(Math.random() * max);
};
